import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stopReload"]
  static values = { interval: Number }

  disconnect() {
    clearInterval(this.i)
  }

  connect() {
    if (this.hasStopReloadTarget) return

    let interval = this.intervalValue || 3000
    this.i = setInterval(() => {
      if (this.hasStopReloadTarget) {
        clearInterval(this.i)
        return
      }

      if (!this.element.checkVisibility()) return

      Turbo.visit(window.location, { frame: this.element.id })
    }, interval)
  }
}
